
export const IDS = {
    // module
    accreditation:                    'accreditation',
    // components
    accDashboardLocationYear: 'accDashboardLocationYear',

    // paths
    addRegulatoryFramework: 'addRegulatoryFramework',

    // states:
    app_accreditation_dashboard: 'app.accreditation.dashboard',
    // reference to requirements assessment module
    app_accreditation_scheme_requirements_assessment_dashboard: 'app.accreditation.scheme.requirements-assessment.dashboard',
};
